import { computed } from 'vue';
import useMeta from './useMeta';

export default function useMetaContext(aMetaObj) {
  const meta = aMetaObj || useMeta();
  return computed(() => meta.value?.context || {});
}
